<template>
    <div class="body-inner">
        <header-component></header-component>
        <!-- Page title -->
        <!--<section id="page-title">
            <div class="container">
                <div class="page-title">
                    <div class="row">
                        <div class="col-md-6">
                            <h2 class="text-secondary">Bienvenido al catálogo<br>de soluciones <span class="font-weight-light">Pro</span></h2>
                        </div>
                        <div class="col-md-6">
                            <h3>¿Eres estudiante, docente o directivo en una institución académica?</h3>
                            <p>Conoce los beneficios que tenemos para ti:</p>
                            <a class="btn" data-target="#modal" data-toggle="modal" href="#">Haz clic</a>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->
        <!-- Shop products -->
        <section>
            <div class="container">
                <div class="row">
                    <div class="col-lg-4" v-for="producto in productosCatalogo" :key="producto.id">
                        <div class="card">
                            <img class="card-img-top" :src="producto.imagen_store">
                            <div class="card-body">
                                <h5 class="card-title">{{ producto.nombre }}</h5>
                                <p class="card-text">{{ producto.descripcion }}</p>
                                <router-link :to="`/detalle-producto/${producto.id}`" class="btn btn-xs btn-primary">Ver detalles</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Footer -->
        <footer id="footer">
            <div class="copyright-content">
                <div class="container">
                    <div class="copyright-text text-center">&copy; 2020 <a href="https://etciberoamerica.com/" target="_blank" rel="noopener">ETC IBEROAMÉRICA.</a> </div>
                </div>
            </div>
        </footer>
        <!-- end: Footer -->
    </div>
</template>

<script>
/* eslint-disable */
import HeaderComponent from './components/HeaderComponent'
export default {
    name: 'Productos',
    components: {
    HeaderComponent
    },
    data() {
        return {
            productosCatalogo: [],
            hostname: '',
        }
    },

    methods: {

    },
    async mounted() {
        console.log(hostname);
        this.hostname = hostname
        const script = document.createElement('script')
        script.src = '/js/functions.js'
        script.id = 'functionScript'
        document.body.appendChild(script)

        this.openLoading()
        if(this.hostname == 'innovaccion.etciberoamerica.com')
            await this.getProductos('api/productos?aparece_index=1&clave=MOS')
        if(this.hostname == 'store.etciberoamerica.com')
            await this.getProductos('api/productos?aparece_index=1')
        if(this.hostname == 'storebpo.etciberoamerica.com')
            await this.getProductos('api/productos?aparece_index=1&claves=MOS,IC3,Lingo')
        Swal.close()
    },
    beforeDestroy() {
        const scriptElem = document.getElementById('functionScript'); 
        scriptElem.remove()
    }
}
</script>
